import { render, staticRenderFns } from "./benefits-tabs.vue?vue&type=template&id=0d8a5034&scoped=true"
import script from "./benefits-tabs.vue?vue&type=script&lang=js"
export * from "./benefits-tabs.vue?vue&type=script&lang=js"
import style0 from "./benefits-tabs.vue?vue&type=style&index=0&id=0d8a5034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a5034",
  null
  
)

export default component.exports